/**
 * Login Component
 */

import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { settingsAPI } from '../services/api';
import './Login.css';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [headerTitle, setHeaderTitle] = useState('Der Starke Franz');
  const [headerSubtitle, setHeaderSubtitle] = useState('Training buchen');

  const { login } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    settingsAPI.getPublicSettings().then(res => {
      if (res.data?.header_title) setHeaderTitle(res.data.header_title);
      if (res.data?.header_subtitle) setHeaderSubtitle(res.data.header_subtitle);
    }).catch(() => {});
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    const result = await login(email, password);

    if (result.success) {
      navigate('/');
    } else {
      setError(result.error);
    }

    setLoading(false);
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <h1>{headerTitle}</h1>
        <h2>{headerSubtitle}</h2>

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>E-Mail</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              placeholder="deine@email.com"
            />
          </div>

          <div className="form-group">
            <label>Passwort</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              placeholder="••••••••"
            />
          </div>

          {error && <div className="error-message">{error}</div>}

          <button type="submit" disabled={loading}>
            {loading ? 'Anmelden...' : 'Anmelden'}
          </button>

          <Link to="/forgot-password" style={{ display: 'block', textAlign: 'center', color: '#c87a3e', fontWeight: '600', fontSize: '14px', marginTop: '20px' }}>
            Passwort vergessen?
          </Link>
        </form>
      </div>
    </div>
  );
};

export default Login;
